<template>
  <div class="DarkWhite">
    <v-card
      class="mb-5"
    >
        <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="FundCode"
            item-text="Description"
            item-value="FundCode"
            :items="funds"
            hide-details
            color="header"
            label="Filter by Funds"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="ClassificationID"
            item-text="Code"
            item-value="ClassificationID"
            :items="classifications"
            hide-details
            color="header"
            label="Filter by Classification"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-menu
              dense
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="DateRange"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="DateRange"
                  label="Date Range"
                  color="header"
                  v-bind="attrs"
                  v-on="on"
                  class="mt-5"
                  hide-details
                  clearable
                >
                </v-combobox>
              </template>
              <v-date-picker
                v-model="DateRange"
                no-title
                scrollable
                range
                color="header"
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="header" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  class="white--text"
                  color="header"
                  @click="$refs.menu1.save(DateRange)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="UserID"
            item-text="name"
            item-value="UserID"
            :items="users"
            hide-details
            color="header"
            label="Filter by User"
          >
          </v-autocomplete>
          </v-col>
          <!-- <v-col cols="12">
            <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search Item here..."
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
            v-model="DisposeTypeID"
            item-text="description"
            item-value="id"
            :items="dispose_types"
            hide-details
            color="header"
            label="Filter by Type"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" align="end">
            <v-btn
              color="green darken-2"
              class="white--text mr-2 my-2"
              :disabled="FundCode == 0 || DisposeTypeID != 1"
              @click="printWMR()"
            >
              <v-icon class="mr-1">mdi-printer</v-icon>
              WMR
            </v-btn>
            <v-btn
              color="green darken-2"
              class="white--text mr-2 my-2"
              :disabled="FundCode == 0 || DisposeTypeID != 2"
              @click="printIIRUSP()"
            >
              <v-icon class="mr-1">mdi-printer</v-icon>
              IIRUSP
            </v-btn>
            <v-btn
              color="green darken-2"
              class="white--text mr-2 my-2"
              :disabled="FundCode == 0 || DisposeTypeID != 3"
              @click="printIIRUP()"
            >
              <v-icon class="mr-1">mdi-printer</v-icon>
              IIRUP
            </v-btn>
          </v-col>
        </v-row>
        </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="itemList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            style="max-width: 300px"
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search Stock/Property here"
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            StockPropertyNo: { title: 'Stock/Property No' },
            RSCODE: { title: 'RS Code' },
            ItemName: { title: 'ItemName' },
            ItemDescription: { title: 'ItemDescription' },
            Qty: { title: 'Qty' },
            DateDisposed: { title: 'Date Disposed' },
            }"
          csv-title="Returned Items">
            <v-btn
              outlined
              color="green darken-2"
              class="mr-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
            <v-btn
              color="red darken-2"
              dark
              @click="dispose()"
            >
              <v-icon class="mr-1">mdi-delete-variant</v-icon>
              <!-- <v-chip label small color="#dc5656" class="mr-1 px-2 white--text darken-2" v-if="itemListDisposal.length > 0"><strong>{{itemListDisposal.length}}</strong></v-chip> -->
              DISPOSE AN ITEM
            </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Qty`]="{ item }">
        {{ formatQty(item.Qty) }}
      </template>
      <template v-slot:[`item.DateDisposed`]="{ item }">
        {{ formatDate(item.DateDisposed) }}
      </template>
      <template v-slot:[`item.ReturnTypeID`]="{ item }">
        <span v-if="item.ReturnTypeID == 1" style="color: green">{{ item.Status }}</span>
        <span v-else-if="item.ReturnTypeID == 2" style="color: red">{{ item.Status }}</span>
        <span v-else style="color: grey">{{ item.Status }}</span>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <v-btn
            color="red darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="undispose(item)"
          >
            Undispose
          </v-btn>
          <v-btn
            color="blue darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="view(item)"
          >
            View RS
          </v-btn>
          <v-btn
            color="green darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="print(item)"
          >
            Print RS
          </v-btn>
        </span>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogPrint" max-width="500px">
          <v-card>
            <v-card-title class="headline pt-5">Generate
              <span v-if="action_type == 1" class="ml-1">WMR</span>
              <span v-if="action_type == 2" class="ml-1">IIRUSP</span>
              <span v-else-if="action_type == 3" class="ml-1">IIRUP</span>
            </v-card-title>
            <div class="mx-6">
              <v-form @submit.prevent ref="Formref">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                  v-model="FundCode"
                  item-text="Description"
                  item-value="FundCode"
                  :items="funds"
                  hide-details
                  color="header"
                  label="Filter by Funds"
                  :rules="[formRules.required]"
                >
                </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                  v-model="ClassificationID"
                  item-text="Code"
                  item-value="ClassificationID"
                  :items="classifications"
                  hide-details
                  color="header"
                  label="Filter by Classification"
                  :rules="[formRules.numberRequiredZeroAllowed]"
                >
                </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                          v-model="DateType"
                          hide-details
                          color="header"
                          label="Generate items in Date Range"
                        />
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-if="DateType"
                    dense
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="DateRange"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-combobox
                        dense
                        v-model="DateRange"
                        label="Date Range"
                        color="header"
                        v-bind="attrs"
                        v-on="on"
                        class="mt-5"
                        hide-details
                        clearable
                        :rules="[formRules.required]"
                      >
                      </v-combobox>
                    </template>
                    <v-date-picker
                      v-model="DateRange"
                      no-title
                      scrollable
                      range
                      color="header"
                      :max="new Date().toISOString().substr(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="header" @click="menu2 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        class="white--text"
                        color="header"
                        @click="$refs.menu2.save(DateRange)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>

                  <v-menu
                    v-if="!DateType"
                    dense
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :return-value.sync="DateEnd"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-combobox
                        dense
                        v-model="DateEnd"
                        label="Date (As of)"
                        color="header"
                        v-bind="attrs"
                        v-on="on"
                        class="mt-5"
                        hide-details
                        clearable
                        :rules="[formRules.required]"
                      >
                      </v-combobox>
                    </template>
                    <v-date-picker
                      v-model="DateEnd"
                      no-title
                      scrollable
                      color="header"
                      :max="new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().substr(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="header" @click="menu3 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        class="white--text"
                        color="header"
                        @click="$refs.menu3.save(DateEnd)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              </v-form>
            </div>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-2" outlined @click="dialogPrint = false">Cancel</v-btn>
              <v-btn color="header white--text" @click="confirmPrint()" :disabled="FundCode == 0 || action_type == null"><v-icon>mdi-printer</v-icon> Print</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showUndisposal" max-width="500px">
          <v-card>
            <v-card-title class="headline">Confirmation</v-card-title>
            <div class="mx-6">
              Are you sure you want to <b>UNDISPOSE</b> this item?
            </div>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-2" outlined @click="showUndisposal = false">Cancel</v-btn>
              <v-btn color="red darken-2 white--text" @click="confirmUndispose()">Undispose</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    <RSModal :rsData="viewData" />
    <DisposeModal :display="showDisposal" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    RSModal: () => import("./ViewRS.vue"),
    DisposeModal: () => import("./DisposeItems.vue"),
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    searchText: "",
    searchTimeout: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    itemList: [],
    headers: [
      {
          text: 'Stock/Property No.',
          align: 'start',
          sortable: false,
          value: 'StockPropertyNo',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'RS CODE',
          align: 'start',
          sortable: false,
          value: 'RSCODE',
          width: '100',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Item Name',
          align: 'start',
          sortable: false,
          value: 'ItemName',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Item Description',
          align: 'start',
          sortable: false,
          value: 'ItemDescription',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Qty',
          align: 'center',
          sortable: false,
          value: 'Qty',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        // {
        //   text: 'UnitCost',
        //   align: 'start',
        //   sortable: false,
        //   value: 'UnitCost',
        //   class: "green darken-2 white--text text-caption font-weight-bold"
        // },
        {
          text: 'Date Disposed',
          align: 'center',
          sortable: false,
          value: 'DateDisposed',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        // {
        //   text: 'Status',
        //   align: 'center',
        //   sortable: false,
        //   value: 'ReturnTypeID',
        //   class: "green darken-2 white--text text-caption font-weight-bold"
        // },
        { text: 'Actions', value: 'Actions', align: 'center', width: '140', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      FundCode: 0,
      ClassificationID: 0,
      UserID: 0,
      DisposeTypeID: 0,
      Status: 0,
      funds: [],
      classifications: [],
      users: [],
      DateRange: null,
      return_types: [],
      dialogPrint: false,
      menu1: false,
      menu2: false,
      menu3: false,
      DateType: false,
      DateEnd: null,
      itemListForCSV: [],
      loadingCSV: true,
      viewData: [],
      undisposeData: [],
      itemListDisposal: [],
      showDisposal: false,
      showUndisposal: false,
      action_type: null,
      dispose_types: [
        {id: 0, description: 'All'},
        {id: 1, description: 'Materials'},
        {id: 2, description: 'Semi-Expendable Properties'},
        {id: 3, description: 'Properties'},
      ],
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    FundCode: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    ClassificationID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    UserID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    DateRange: {
      handler(data) {
        if(data != null){
          this.DateType = true;
        }
        this.initialize();
      },
      deep: true,
    },
    DisposeTypeID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllReturnType();
    this.getFundCodes();
    this.getClassificationByType();
    this.getBudgetTypeAndOffice();
    this.eventHub.$on("closeViewSC", () => {
      this.initialize();
    });
    this.eventHub.$on("closeDisposeItems", () => {
      this.showDisposal = false;
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewSC");
    this.eventHub.$off("closeDisposeItems");
  },
  methods: {
    view(item) {
      this.viewData = item;
    },
    print(item) {
      let link = this.apiUrl + "/rs/report/" + item.RSID;
      window.open(link);
    },
    printIIRUP(){
      this.action_type = 3;
      this.dialogPrint = true;
    },
    printIIRUSP(){
      this.action_type = 2;
      this.dialogPrint = true;
    },
    printWMR(){
      this.action_type = 1;
      this.dialogPrint = true;
    },
    dispose() {
      this.showDisposal = true
    },
    undispose(data) {
      this.undisposeData = data
      this.showUndisposal = true
    },
    initialize() {
      this.loading = true;
      this.loadingCSV = true;
      if(this.fiscalYear != null){
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("tab", this.tab);
      data.append("searchText", this.searchText);
      data.append("FiscalYearID", this.fiscalYear);
      data.append("ClassificationID", this.ClassificationID);
      data.append("FundCode", this.FundCode);
      data.append("UserID", this.UserID);
      data.append("DateRange", this.DateRange && this.DateRange.length > 1 ? this.DateRange : '');
      data.append("DisposeTypeID", this.DisposeTypeID);
      this.axiosCall("/getDisposedItemList", "POST", data).then((res) => {
        this.loading = false;
        this.loadingCSV = false;
        this.itemList = res.data.data.result;
        this.itemListForCSV = res.data.data.result
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
      }
    },
    confirmUndispose(){
        let data = new FormData();
        let type = this.undisposeData.ICSID ? 1 : this.undisposeData.PARID ? 2 : 0;
        data.append("ItemDID", this.undisposeData.ICSID ? this.undisposeData.ICSItemDID : this.undisposeData.PARID ? this.undisposeData.ICSItemDID : '');
        data.append("type", type);
        this.axiosCall("/undisposeItem", "POST", data).then((res) => {
          console.log(res);
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Item Successfully undisposed.";
          this.fadeAwayMessage.header = "System Message";
          this.undisposeData = [];
          this.showUndisposal = false;
          this.initialize();
        });
    },
    confirmPrint(){
      if (this.$refs.Formref.validate()) {
      let dates = this.DateRange || [0,0];
      let DateStart = dates[0];
      let DateEnd = dates[1];
      if(this.DateType == false){
        DateStart = 0;
        DateEnd = this.DateEnd;
      }
      let type = '';
      if(this.action_type == 1){
        type = 'wmr'
      }
      else if(this.action_type == 2){
        type = 'iirusp'
      }
      else if(this.action_type == 3){
        type = 'iirup'
      }
      let link = this.apiUrl + "/" + type + "/report/" + DateStart + "/" + DateEnd + "/" + this.ClassificationID + "/" + this.FundCode;
      window.open(link);
      }
    },
    getAllReturnType() {
      this.axiosCall(
              '/getAllReturnType',
              'GET'
          )
          .then((res) => {
              this.return_types = this.prepend({id: 0, description: 'All'},res.data.data);
          })
		},
    getFundCodes() {
      this.axiosCall(
              '/get/getUniqueFundCodes',
              'GET'
          )
          .then((res) => {
              this.funds = this.prepend({FundCode: 0, Description: 'All'},res.data.data);
          })
		},
    getClassificationByType() {
      this.axiosCall(
              '/get/getClassificationByType/1/1',
              'GET'
          )
          .then((res) => {
              this.classifications = this.prepend({ClassificationID: 0, Code: 'All'},res.data.data);
          })
		},
    getBudgetTypeAndOffice() {
      this.axiosCall(
              '/getOfficeAndOthersForCreateUpdate',
              'GET'
          )
          .then((res) => {
              this.users = this.prepend({UserID: 0, name: 'All'},res.data.data.users);
          })
		},
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
  },
};
</script>